<template>
  <observation/>
</template>

<script>
  import { mapState } from 'vuex';
  import Observation from '../components/Observation'
  import ACTIONS from '../storeActions';

  export default {
    name: 'ObservationPage',
    components: {
      Observation,
    },
    data() {
      return {
        saveTimer: {},
        observationsToSave: {}
      }
    },
    computed: {
      ...mapState(['currentParticipantId', 'currentExerciseId', 'currentInterviewId'])
    },
    mounted() {
      if (this.currentInterviewId) this.$router.push({ name: 'interview' })
      if (!this.currentParticipantId || !this.currentExerciseId) {
        this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noExerciseSelected'), color: 'error' } );
        this.$router.push({ name: 'overview' });
      }
    },
  }
</script>
